import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
// import { AvatarStack } from '@/components/custom/avatar/avatar';
import { PiStudent } from 'react-icons/pi';
import { FiStar, FiUsers, FiChevronDown } from 'react-icons/fi';
import { TbCopy } from 'react-icons/tb';
import toast from 'react-hot-toast';
import { useClient } from 'jsonapi-react';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { useFormik } from 'formik';
import { ModalWarning } from '@/components/custom/modal/modal-warning';
import usePermission from '@/hooks/usePermission';
import promiseRequest from '@/utils/promiseToast';
import { IconVerified } from '@/components/custom/icon';
import { useSession } from '@/hooks/useSession';
import {
  CourseCardAdmin,
  CourseCardAdminBody,
  CourseCardAdminContent,
  CourseCardAdminFooter,
  CourseCardAdminHeader,
  CourseCardAdminHeaderContent,
  CourseCardAdminImage,
  CourseCardAdminImageWrapper,
  CourseCardAdminRating,
  CourseCardAdminTitle
} from '@/components/custom/course';
import { ButtonGroup } from '@/components/ui/button-group';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { CardKpi, CardKpiGrid, CardKpiTitle } from '@/components/ui/card';
import { FormSwitch } from '@/components/custom/form';
// import { Badge } from '@/components/ui/badge';

export default function CourseAdminCard(props) {
  const navigate = useNavigate();
  const { course, setFilteredCourses, handleOpenClassroomModal, handleOpenModulesModal } = props;
  const client = useClient();
  const [showWarning, setShowWarning] = useState(false);
  const [showPublishWarning, setShowPublishWarning] = useState(false);

  const { promiseToast, isSubmitting } = promiseRequest();

  const handleDelete = () => {
    Swal.fire({
      title: t('projects.warningDeleteCourse'),
      confirmButtonText: t('button.yes'),
      showDenyButton: true,
      denyButtonText: t('button.no'),
      showCloseButton: true
    }).then(res => {
      if (res.isConfirmed) {
        deleteCourse();
      }
    });
  };

  const courseForm = useFormik({
    initialValues: {
      published: course?.published
    }
  });

  useEffect(() => {
    courseForm.setFieldValue('published', course?.published);
  }, [course.published]);

  const deleteCourse = async () => {
    const { error } = await client.delete(['/courses', course.id]);
    if (error) {
      toast.error('Erro ao excluir curso');
    } else {
      toast.success('Curso excluído!');
      setFilteredCourses(prevState => prevState.filter(item => item.id !== course.id));
    }
  };

  const updateCoursePublicity = async values => {
    promiseToast({
      url: `courses/${course.id}`,
      request: {
        published: !values.published
      },
      successText: !courseForm.values.published ? 'Publicado com sucesso!' : 'Despublicado com sucesso!',
      errorText: 'Erro ao publicar curso'
    }).then(() => {
      courseForm.setFieldValue('published', !courseForm.values.published);
      setShowWarning(false);
      setShowPublishWarning(false);
    });
  };

  const handlePublishCourse = () => {
    if (course?.['learning-systems-count'] === 0 && !courseForm.values.published) {
      setShowWarning(true);
    } else if (courseForm.values.published) {
      setShowPublishWarning(true);
    } else {
      updateCoursePublicity(courseForm.values);
    }
  };

  const currentUser = useSession()?.session?.user;
  const hasPermissionToPublish = usePermission('Gerenciar conteúdo', 'Cursos');
  const isCreatorOrAdmin = !course?.['authored-by-user'] || (course?.['authored-by-user'] && currentUser.id === course?.['creator-id']) || currentUser?.profileNames.includes('Administrador');

  return (
    <CourseCardAdmin>
      <CourseCardAdminImageWrapper>
        <CourseCardAdminImage
          src={course?.image?.url}
          alt=""
        />
        {/* <Badge className="absolute left-3 top-3 z-[1]">{course?.knowledge}</Badge> */}
      </CourseCardAdminImageWrapper>

      <CourseCardAdminContent>
        <CourseCardAdminHeader>
          <CourseCardAdminHeaderContent>
            {course?.['official-content'] && <IconVerified />}
            <CourseCardAdminTitle>{course?.title}</CourseCardAdminTitle>
          </CourseCardAdminHeaderContent>

          {hasPermissionToPublish && isCreatorOrAdmin && (
            <FormSwitch
              label={t('lms.publish')}
              checked={courseForm.values.published}
              onCheckedChange={handlePublishCourse}
            />
          )}
        </CourseCardAdminHeader>

        <CourseCardAdminBody>
          <CardKpiGrid>
            {/* <CardKpi>
                <CardKpiTitle>{t('courses.managers')}</CardKpiTitle>
                <FiUsers size={20} className="text-primary" /> {course?.['manager-count']}
              </CardKpi> */}
            <CardKpi>
              <CardKpiTitle>{t('projects.titleStudents')}</CardKpiTitle>
              <PiStudent
                size={20}
                className="text-primary"
              />{' '}
              {course?.['student-count']}
            </CardKpi>
            <CardKpi
              clickable
              onClick={() => handleOpenModulesModal(course)}
            >
              <CardKpiTitle>{t('textsCommon.publishedModules')}</CardKpiTitle>
              <TbCopy
                size={20}
                className="text-primary"
              />{' '}
              {course?.['learning-systems-count']}
            </CardKpi>
            {/* <CardKpi
                clickable
                onClick={() => handleOpenClassroomModal(course)}
              >
                <CardKpiTitle>{t('courses.classes')}</CardKpiTitle>
                <FiUsers size={20} className="text-primary" /> {course?.['classroom-count']}
              </CardKpi> */}
          </CardKpiGrid>
        </CourseCardAdminBody>

        <CourseCardAdminFooter>
          <CourseCardAdminRating>
            <FiStar /> {parseFloat(course?.rating).toFixed(1)} <span>({course?.['total-reviews']})</span>
          </CourseCardAdminRating>

          <ButtonGroup className="w-full">
            <Button
              variant="outline"
              size="sm"
              fullWidth
              asChild
            >
              <Link to={`/curso/admin/${course?.id}`}>{t('button.view')}</Link>
            </Button>

            {usePermission('Editar cursos', 'Cursos') || usePermission('Excluir cursos', 'Cursos') ? (
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button
                    variant="outline"
                    size="sm"
                  >
                    <FiChevronDown size={20} />
                  </Button>
                </DropdownMenuTrigger>

                <DropdownMenuContent align="end">
                  {isCreatorOrAdmin && usePermission('Editar cursos', 'Cursos') && (
                    <DropdownMenuItem
                      onClick={() => {
                        navigate(`/curso/criar/sobre/${course?.id}`);
                      }}
                    >
                      {t('button.edit')}
                    </DropdownMenuItem>
                  )}
                  {isCreatorOrAdmin && usePermission('Excluir cursos', 'Cursos') && <DropdownMenuItem onClick={handleDelete}>{t('button.delete')}</DropdownMenuItem>}
                  <DropdownMenuItem asChild>
                    <Link to="/metricas/institucional">{t('button.viewMetrics')}</Link>
                  </DropdownMenuItem>
                  {isCreatorOrAdmin && (
                    <DropdownMenuItem asChild>
                      <Link to={`/curso/admin/gerenciar/${course?.id}/m/disciplinas-e-aulas/d`}>{t('button.manageContent')}</Link>
                    </DropdownMenuItem>
                  )}
                </DropdownMenuContent>
              </DropdownMenu>
            ) : null}
          </ButtonGroup>
        </CourseCardAdminFooter>
      </CourseCardAdminContent>

      <ModalWarning
        isSubmitting={isSubmitting}
        show={showWarning}
        titleFirstButton="Confirmo que quero publicar"
        titleSecondButton="Manter despublicado"
        onClose={() => setShowWarning(false)}
        title={'Você tem certeza que deseja publicar o curso sem módulos e aulas publicados?'}
        description={'Ele aparecerá sem conteúdo pois não há módulos e aulas publicados para os estudantes.'}
        onSubmitFirstButton={() => updateCoursePublicity(courseForm.values)}
        onSubmitSecondButton={() => setShowWarning(false)}
      />

      <ModalWarning
        isSubmitting={isSubmitting}
        show={showPublishWarning}
        titleFirstButton="Confirmo que quero despublicar"
        titleSecondButton="Manter publicado"
        onClose={() => setShowPublishWarning(false)}
        title={'Ao despublicar, este conteúdo ficará invisível para os alunos.'}
        description={'Você pode publicá-lo novamente a qualquer momento. Deseja prosseguir com a despublicação?'}
        onSubmitFirstButton={() => updateCoursePublicity(courseForm.values)}
        onSubmitSecondButton={() => setShowPublishWarning(false)}
      />
    </CourseCardAdmin>
  );
}
